export default function ErrorMessage({ title, message }) {
    return <div className="error-message-overlay">
        <div className="error-message-box">
            <div className="error-message-title">{title}</div>
            <div className="error-message-message">{message}</div>
        </div>
    </div>
}